/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GlobeStrikeClockIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Globe Strike Clock',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M27 18.084a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm0 15.9a7 7 0 1 1 7-7 7 7 0 0 1-7 7Z"
    />
    <path
      d="M27.905 26.517v-4.128a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v5.229l3.275 2.072a.5.5 0 0 0 .69-.155l.535-.845a.5.5 0 0 0-.155-.69ZM14.7 27a12.318 12.318 0 0 1 .408-3.1 50.167 50.167 0 0 0-2.772-4.5c-2.073-3.086-3.958-1.178-5.19-5.636a6.06 6.06 0 0 1-.21-1.883L4.509 9.458A16.017 16.017 0 0 0 2 18c0 9.112 7.943 14.542 13.554 15.732a6.889 6.889 0 0 0 1.046.168c.03-.077.047-.155.074-.232A12.232 12.232 0 0 1 14.7 27ZM17.314 19.436a12.371 12.371 0 0 1 2.121-2.121L4.551 2.429a.509.509 0 0 0-.72 0l-1.4 1.4a.509.509 0 0 0 0 .719ZM16.027 4.654a3.711 3.711 0 0 0-1.1-.452c-1.818-.211.88 4.777.777 4.114.5-2.292 3.612-3.176 4.565-.147a3.742 3.742 0 0 1-.837 2.265 10.193 10.193 0 0 0-1.314 2.737l3.014 3.014A12.242 12.242 0 0 1 29.672 15v-.133a5.766 5.766 0 0 1 1.666-4 3.1 3.1 0 0 1 .73-.349c-.192-.349-.4-.684-.62-1.018-.037.019-.07.044-.109.062-1.25.583-1.423.755-2 0a1.576 1.576 0 0 1 .347-2.326 15.984 15.984 0 0 0-11.66-5.221c2.027.028 4.446 1.53 3.213 3.929.186-.381-4.027-1.29-4.6-1.29-.772 0 1.575-2.889 1.36-2.639a16.085 16.085 0 0 0-6.615 1.423c1.094.706 2.311.46 3.544.764a3.014 3.014 0 0 1 1.099.452Z"
    />
  </svg>`;
};
